/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- ADD-ON TYPES COMMUNITY TOP ARTICLES TIMEFRAME: STYLES --------------- ++++++++++ */
export default theme => ({
    timeframe: {
        '& .sectioncontent': {
            display: 'flex',
            flexFlow: 'row wrap',
            width: '100%',
            '& .control': {
                minWidth: pxToEm(172),
                marginBottom: pxToEm(8),
                marginRight: pxToEm(8)
            },
            '& .daysfield': {
                display: 'inline',
                marginLeft: pxToEm(32),
                '& .field': {
                    maxWidth: pxToEm(76),
                    margin: `0 ${pxToEm(16)}`,
                    '& .errormessage': {
                        width: pxToRem(170),
                        position: 'absolute',
                        left: `-${pxToRem(40)}`
                    }
                }
            }
        }
    }
});
